const normalizeDtoValue = (value) => {
    if (Array.isArray(value)) return value.map(normalizeDtoValue);
    if (!value || typeof value !== 'object') return value;
    return Object.keys(value).sort().reduce((normalized, key) => {
        if (value[key] !== undefined) normalized[key] = normalizeDtoValue(value[key]);
        return normalized;
    }, {});
};

export const stableDtoStringify = value => JSON.stringify(normalizeDtoValue(value));

export const dtoValuesEqual = (left, right) => (
    left === right || stableDtoStringify(left) === stableDtoStringify(right)
);
